import React from "react";
import styled from "styled-components";
import Players from "../Player/Players";

const Main = styled.div`
  padding-top: 52px;
  margin-bottom: 52px;
`;

export default function () {
  return (
    <Main>
      <Players />
    </Main>
  );
}
